// @flow weak

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import AsyncIndicator from 'app/common/components/AsyncIndicator';
import Button from 'app/common/components/Button';
import 'app/common/components/AsyncButton.scss';

import type { Node } from 'react';

import type { KindType } from 'app/common/types';

const bem = bemify('async-button');

export type AsyncButtonProps = {
  isWorking: boolean,
  disabled?: boolean,
  className?: string,
  kind?: KindType,
  children?: Node,
};

const AsyncButton = (componentProps: AsyncButtonProps) => {
  const { isWorking, ...props } = componentProps;
  const className = bem(toModifiers(props.kind), props.className);
  const indicator = !isWorking ? null : (
    <AsyncIndicator
      className={bem('__indicator')}
      height={5}
      kind="inherit-color"
    />
  );
  return (
    <Button
      {...props}
      className={className}
      disabled={props.disabled || isWorking}
    >
      <span className={bem('__text', { '--invisible': isWorking })}>
        {props.children}
      </span>
      {indicator}
    </Button>
  );
};

export default AsyncButton;
